export default __webpack_public_path__ + "static/media/pi.b6d53a1e.png";